<template>
  <div class="login_card">
    <div class="login_left">
      <img class="login_left_img" :src="loginImageBase + 'loginbg.png'" alt="" />
    </div>
    <div class="login_box">
      <div class="login_box_img_box">
        <img
          class="login_box_img"
          :src="loginImageBase + 'loginname.png'"
          alt=""
        />
      </div>
      <div v-if="pawdShow" class="login_box_tips">
        账号或密码输入错误，请重新输入
      </div>

      <div class="unamebox">
        <div class="unameimg">
          <img class="login_box_img" :src="loginImageBase + 'uname.png'" alt="" />
        </div>
        <div class="unameinp">
          <el-input
            v-model="loginForm.username"
            class="inp"
            placeholder="请输入账号"
          ></el-input>
        </div>
      </div>
      <div class="upawdbox">
        <div class="unameimg">
          <img class="login_box_img" :src="loginImageBase + 'upawd.png'" alt="" />
        </div>
        <div class="unameinp flex">
          <el-input
            v-model="loginForm.password"
            :type="passwordtype"
            class="inp"
            placeholder="请输入序列号"
          ></el-input>
          <img
            v-if="pawdkai"
            :src="loginImageBase + 'kai.png'"
            alt=""
            class="cipr"
            @click="pawdkan"
          />
          <img
            v-else
            :src="loginImageBase + 'guan.png'"
            alt=""
            class="cipr"
            @click="nopawdkan"
          />
        </div>
      </div>
      <div class="redTips">
        *请输入设备序列号
      </div>

      <div class="denglubtn" @click="login">登录</div>
    </div>

    <div class="copyright">
      @ 2005-2021 MR.FUTURE未来先生版权所有，并保留所有权 | 蜀CP备2021032368号-2
    </div>

    <!-- <el-input
    placeholder="请输入内容"
    suffix-icon="el-icon-date"
    v-model="input1">
  </el-input> -->

    <!-- <div class="login_box_bgimg">
      <span class="logo_word">新华小创服务中心</span>
    <div class="login_box">
      <div class="login_word">登陆</div>
      <el-form
        label-width="0px"
        class="login_form"
        :model="loginForm"
        :rules="loginFormRules"
        ref="loginFormRef"
      >
        <el-form-item
          class="username"
          prop="username"
        >
          <el-input
            v-model="loginForm.username"
            class="inp"
            prefix-icon="iconfont icon-zhanghao"
            placeholder="请输入账号"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="password"
          prop="password"
        >
          <el-input
            v-model="loginForm.password"
            class="inp"
            prefix-icon="iconfont icon-mima"
            placeholder="请输入密码"
            type="password"
          ></el-input>
        </el-form-item>
        <el-form-item class="btns">
          <el-button
            type="primary"
            class="btn"
            @click="login"
          >登陆</el-button>
        </el-form-item>
      </el-form>
    </div> 
    </div>-->
  </div>
</template>

<script>
import { getUrlParam } from "../utils/url";

const DEFAULT_USERNAME = "weilaixiansheng";
const XL_WATER_PASSWORD = "weilaixiansheng";

export default {
  data() {
    return {
      loginForm: {
        username: "",
        password: ""
      },
      pawdkai: true,
      pawdShow: false,
      passwordtype: "password",
      loginImageBase: `${process.env.BASE_URL}images/login/`,
      isLoggingIn: false
    };
  },
  created() {
    this.getUrlParams();
  },
  methods: {
    getUrlParams() {
      const accessToken = getUrlParam("access_token");
      if (accessToken) {
        this.$store.commit("setVisualizationAccessToken", accessToken);
        const cleanQuery = { ...this.$route.query };
        delete cleanQuery.access_token;
        this.$router.replace({ path: this.$route.path, query: cleanQuery });
      }

      const deviceSn = getUrlParam("s_no");
      if (!deviceSn) {
        return;
      }

      this.loginForm.password = deviceSn;
      this.loginForm.username = DEFAULT_USERNAME;
      this.login();
    },
    login() {
      if (this.isLoggingIn) {
        return;
      }

      const username = this.loginForm.username.trim();
      const serialNumber = this.loginForm.password.trim();
      if (!username || !serialNumber) {
        this.pawdShow = true;
        return;
      }

      this.isLoggingIn = true;
      this.pawdShow = false;
      this.$api.xueLing
        .getSingleDeviceData({
          username,
          s_no: serialNumber
        })
        .then(res => {
          if (res == "noData" || res == "noPermission") {
            this.pawdShow = true;
            return;
          }

          this.$store.commit("setDeviceSession", {
            username,
            password: XL_WATER_PASSWORD,
            serialNumber
          });
          this.$router.push("/");
        })
        .catch(() => {
          this.$message.error("登录失败，请稍后重试");
        })
        .finally(() => {
          this.isLoggingIn = false;
        });
    },
    pawdkan() {
      this.pawdkai = false;
      this.passwordtype = "text";
    },
    nopawdkan() {
      this.pawdkai = true;
      this.passwordtype = "password";
    }
  }
};
</script>

<style lang="less" scoped>
.login_card {
  width: 100vw;
  height: 100vh;
  background-color: #000;
  display: flex;
  align-items: center;
}

.login_left {
  max-width: 70%;
  height: 100%;
  flex: 1;
}

.login_left_img {
  width: 100%;
  height: 100%;
}

.login_box {
  width: 460px;
  height: 540px;
  flex-shrink: 1;
  background: rgba(140, 136, 136, 0.15);
  border-radius: 16px 16px 16px 16px;
  border: 1px solid;
}

.login_box_img_box {
  margin: 0 auto;
  margin-top: 80px;
  width: 316px;
  height: 98px;
}

.login_box_img {
  width: 100%;
  height: 100%;
}

.login_box_tips {
  width: 269px;
  height: 46px;
  line-height: 46px;
  margin: 0 auto;
  text-align: center;
  margin-top: 14px;
  background: linear-gradient(145deg, #575959 0%, #292c2e 100%);
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #676767;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
}

.unamebox {
  display: flex;
  width: 320px;
  height: 48px;
  margin: 0 auto;
  margin-top: 14px;
  align-items: center;
  justify-content: space-evenly;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 8px 8px 8px 8px;
}

.unameimg {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}

.unameinp {
  width: 270px;
  height: 24px;
  border-left: 1px solid rgba(198, 204, 208, 0.08);

  .el-input {
    width: 100%;
    height: 100%;
  }
}

.flex {
  display: flex;
}

.cipr {
  cursor: pointer;
}

.redTips {
  width: 320px;
  margin-top: 4px;
  margin: 0 auto;
  margin-top: 3px;
  font-weight: 400;
  font-size: 12px;
  color: #ff0000;
}

::v-deep .el-input__inner {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  padding: 0 !important;
  height: 24px !important;
  line-height: 24px !important;
  color: #fff;
  margin-left: 8px;
  width: 80%;
}

.upawdbox {
  display: flex;
  width: 320px;
  height: 48px;
  margin: 0 auto;
  margin-top: 14px;
  align-items: center;
  justify-content: space-evenly;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 8px 8px 8px 8px;
}

::v-deep .el-input__icon {
  width: 25px;
  height: 25px;
  line-height: 25px;
  cursor: pointer;
}

.denglubtn {
  width: 320px;
  height: 48px;
  margin: 0 auto;
  margin-top: 20px;
  line-height: 48px;
  text-align: center;
  background: linear-gradient(180deg, #3fafff 0%, #023ba3 100%);
  border-radius: 8px 8px 8px 8px;
  font-weight: 500;
  font-size: 18px;
  color: rgba(255, 255, 255, 0.85);
  cursor: pointer;
}

.copyright {
  position: fixed;
  bottom: 30px;
  color: rgba(255, 255, 255, 0.6);
  left: 50%;
  transform: translateX(-50%);
}
</style>
